import React, { useState, useEffect } from "react";
import "./Licenses.css";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner"; // Ensure you have this component

const Licenses = () => {
  const [licenses, setLicenses] = useState([]);
  const [loading, setLoading] = useState(true); // Initialize loading state to true
  const [error, setError] = useState(null); // Optional: Handle errors

  useEffect(() => {
    // Fetching licenses data
    fetch("https://api.spadserver.com/api/product/Licenses")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setLicenses(data.data.products);
        setLoading(false); // Stop loading when data is fetched successfully
      })
      .catch((error) => {
        console.error("Error fetching licenses data:", error);
        setError(`Error fetching licenses data: ${error.message}`);
        setLoading(false); // Stop loading even if there's an error
      });
  }, []);

  // Function to strip HTML tags from the description
  const stripHtmlTags = (str) => {
    return str
      .replace(/<\/?[^>]+(>|$)/g, "") // Removes HTML tags
      .replace(/&zwnj;/g, "") // Removes &zwnj;
      .replace(/&nbsp;/g, " "); // Replaces &nbsp; with a regular space
  };

  // Display loading spinner if still fetching data
  if (loading) {
    return <LoadingSpinner />;
  }

  // Optional: Display error message if there was an error
  if (error) {
    return <p>{error}</p>;
  }

  // Function to get image URL based on license index
  const getImageForLicense = (index) => {
    switch (index) {
      case 0:
        return "/images/direct1.png"; // Image for the first license
      case 1:
        return "/images/cpanelLicense.png"; // Image for the second license
      case 2:
        return "/images/cloudLinux.png"; // Image for the third license
      case 3:
        return "/images/jetbackup.png"; // Image for fourth license
      case 4:
        return "/images/whmcs-logo.png"; // Image for fifth license
      case 5:
        return "/images/logo (2).png"; // Image for sixth license
      case 6:
        return "/images/litespeed-logo_darkbg.png"; // Image for seventh license
      case 7:
        return "/images/virtualizor.png"; // Image for eighth license
      case 8:
        return "/images/metal.png"; // Image for ninth license
      case 9:
        return "/images/sonic (2).png"; // Image for tenth license
      default:
        return "/images/default.png"; // Fallback image
    }
  };

  return (
    <div className="">
      <div className="mx-12 text-white mb-10">
        <h1 className="text-2xl font-bold mb-10">لایسنس‌های هاستینگ و سرور</h1>
        <div className="flex justify-center mb-20">
          تیم اسپاد سرور جهت حمایت از کسب و کارهای نوپا و به حداقل رساندن هزینه‌ها
          اقدام به ارائه لایسنس‌هایی با هزینه‌ی مناسب نموده است.
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
          {licenses.map((license, index) => {
            const imageUrl = getImageForLicense(index);

            return (
              <div key={index} className="card-container">
                <div className="licenses-content">
                  <div className="image-title-container">
                    <img
                      className="licenses-image"
                      src={imageUrl}
                      alt={license.title}
                    />
                  </div>
                  <h2 className="licenses-text font-semibold flex justify-center mt-8 md:text-[16px]">
                    {license.title}
                  </h2>
                  <div className="flex justify-center annually text-[9px]">
                    (ماهانه)
                  </div>
                  <div className="bottom-content flex justify-between">
                    <p className="mt-2 font-bold text-sm">
                      {license.monthly} {license.currency.suffix}
                    </p>
                    <a href={license.slug} className="purchase-button mr-10">
                      خرید لایسنس
                    </a>
                  </div>
                </div>
                <div className="licenses-description">
                  <p className="text-[14px]">{stripHtmlTags(license.desc)}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Static Design Section */}
      <div
        className="textSiteDesign text-white flex flex-col items-center justify-center p-4"
        style={{
          backgroundColor: "rgba(128, 128, 128, 0.3)",
          width: "100%",
        }}
      >
        <p className="text-center mt-10 text-xl font-bold">طراحی سایت</p>
        <div className="text-md mt-8 mb-8 px-4 sm:mt-10 sm:mb-10 sm:px-6 md:mt-12 md:mb-12 md:px-8 lg:mt-14 lg:mb-14 lg:px-10 xl:mt-16 xl:mb-16 xl:px-12 text-justify lg:text-[15px]">
          <p>
            با خدمات طراحی سایت اسپاد سرور، کسب‌وکار آنلاین خود را به سطح جدیدی
            ببرید. ما با استفاده از آخرین تکنولوژی‌ها و طراحی‌های مدرن، وب‌سایتی
            منحصربه‌فرد و حرفه‌ای برای شما ایجاد می‌کنیم.
          </p>
        </div>

        <div className="groupButtons xl:w-[450px] md:w-[200px]">
          <img src="/images/groupButtons.png" alt="" />
        </div>
        <div className="mainPageRequest text-center mt-4">
          <a
            href="https://crm.spadserver.com/submitticket.php?step=2&deptid=8"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="bg-red-400 p-3 w-40 rounded-[30px] mt-10 request">
              ارسال درخواست
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Licenses;
